import { Command, UndoState } from "~/utils";
import { Game } from "./Game";
import { GameCommandByPlayer } from "./GameApi";
import { FactionType } from "./constant";
import { AgentEffectDescription } from "./effect";

const gameEventApi = {
  conflictWon() {},
  freeControlTroop(props: { playerId: string; slotId: string }) {},
  controlBonus(props: {
    playerId: string;
    slotId: string;
    effect: AgentEffectDescription;
  }) {},
  factionBonus(props: {
    playerId: string;
    effect: AgentEffectDescription;
    faction: FactionType;
  }) {},
  revealAll(props: { playerId: string }) {},
  endBuyPhase(props: { playerId: string }) {},
  stealIntrigueCard(props: { fromPlayerId: string; toPlayerId: string }) {},
};

export const gameEventBuilder = Command.builder(gameEventApi);

type GameEventApi = typeof gameEventApi;
export type GameInfoEvent = Command<GameEventApi>;

export const getGameEventInfoArg = <Key extends keyof GameEventApi>(
  event: Command<GameEventApi>
): Command<GameEventApi, Key>["arg"] => {
  return event.arg;
};

export type GameEvent = (
  | (GameInfoEvent & { isInfo: true })
  | GameCommandByPlayer
) & { game: Game; undoState: UndoState };

export const GameEvent = {
  isGameInfoEvent(
    event: GameEvent
  ): event is GameInfoEvent & {
    game: Game;
    undoState: UndoState;
    isInfo: true;
  } {
    return "isInfo" in event && event.isInfo;
  },
};
